import { makeStyles } from '@mui/styles';
import { FONT_ENUM } from '../../types/global/fonts.types';

export const useStyles = makeStyles(theme => ({
    numberHolder: {
        backgroundColor: 'blue', // Change the background color to blue
        color: 'white', // Set the text color to white
        fontWeight: 'bold', // Make the font bold
        width: 3, // Set the width of the number holder
        height: 3, // Set the height of the number holder
        fontSize: '14px', // Set the font size of the number
        borderRadius: '50%', // Make the number holder circular
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    customAvatarGroup: {
        '& .MuiAvatarGroup-avatar': {
            backgroundColor: 'rgba(0,0,0,0.9)', // Change the background color to your desired color
            color: 'white', // Change the text color to your desired color
            fontFamily: FONT_ENUM.REGULAR_HEADER,
            fontSize: 16,
        },
    },
}));
